let html = `<span class="time-line-details" data-hash="{hash}">
#{time_viewed} - <b a="t">{time}</b> #{time_from} <b a="d">{duration} / <b a="p">{percent}</b></b>
</span>`

export default html
